export default function ChinhSach() {
  return (
    <div className="w-full mt-24 md:mt-36 container mx-auto px-4 pb-20 text-gray-800 leading-relaxed">
      <h1 className="text-3xl font-bold mb-8 text-blue-600 text-center uppercase">
        Chính sách bảo mật
      </h1>

      <p className="mb-6 italic text-gray-600">
        BlueSkyIT cam kết bảo vệ sự riêng tư và bảo mật thông tin cá nhân của
        bạn khi truy cập website{" "}
        <span className="font-semibold text-blue-500">BlueskyIT.vn</span>. Vui
        lòng đọc chính sách này để hiểu rõ cách chúng tôi thu thập, sử dụng và
        quản lý thông tin của bạn.
      </p>

      <section className="mb-8">
        <h2 className="text-xl font-bold mb-4 border-b pb-2">
          1. Phạm vi thu thập thông tin
        </h2>
        <p className="mb-2">Chúng tôi thu thập thông tin khi bạn:</p>
        <ul className="list-disc ml-6 mb-4 space-y-1">
          <li>Đăng ký tài khoản trên website.</li>
          <li>Sử dụng các dịch vụ hoặc tính năng cung cấp trên trang web.</li>
          <li>Liên hệ hỗ trợ qua biểu mẫu trên website.</li>
        </ul>
        <p>
          <span className="font-semibold">Thông tin bao gồm:</span> Tên, email,
          số điện thoại, và các thông tin cần thiết khác phục vụ cho việc cung
          cấp dịch vụ. Thông tin truy cập (như địa chỉ IP, trình duyệt, thời
          gian truy cập, trang đã xem).
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-bold mb-4 border-b pb-2">
          2. Mục đích sử dụng thông tin
        </h2>
        <ul className="list-disc ml-6 space-y-2">
          <li>
            Cung cấp dịch vụ, tính năng và hỗ trợ bạn trong quá trình sử dụng
            website.
          </li>
          <li>Nâng cao chất lượng trải nghiệm của người dùng.</li>
          <li>
            Gửi các thông báo quan trọng, thông tin giao dịch, hoặc khuyến mãi.
          </li>
          <li>Đảm bảo an toàn và ngăn chặn các hoạt động gian lận.</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-bold mb-4 border-b pb-2">
          3. Chia sẻ thông tin
        </h2>
        <p className="mb-2">
          Chúng tôi không bán, trao đổi hoặc cung cấp thông tin cá nhân của bạn
          cho bên thứ ba, trừ khi:
        </p>
        <ul className="list-disc ml-6 space-y-2">
          <li>Được bạn đồng ý.</li>
          <li>
            Tuân thủ theo quy định của pháp luật hoặc yêu cầu từ cơ quan chức
            năng.
          </li>
          <li>
            Các bên cung cấp dịch vụ liên quan đến việc duy trì và vận hành
            website.
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-bold mb-4 border-b pb-2">
          4. Lưu trữ và bảo mật thông tin
        </h2>
        <p>
          Thông tin cá nhân của bạn được lưu trữ trên hệ thống đảm bảo bảo mật
          cao và chỉ được truy cập bởi nhân viên có thẩm quyền. Chúng tôi sử
          dụng các biện pháp kỹ thuật và tổ chức để ngăn chặn truy cập trái
          phép, mất mát hoặc rò rỉ thông tin.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-bold mb-4 border-b pb-2">
          5. Quyền lợi của người dùng
        </h2>
        <p>
          Bạn có quyền truy cập, chỉnh sửa hoặc yêu cầu xóa thông tin cá nhân
          của mình. Nếu có bất kỳ vấn đề nào liên quan đến bảo mật, vui lòng
          liên hệ chúng tôi qua email:
          <a
            href="mailto:lienhe@blueskyit.vn"
            className="text-blue-500 hover:underline ml-1"
          >
            lienhe@blueskyit.vn
          </a>
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-bold mb-4 border-b pb-2">
          6. Thay đổi chính sách
        </h2>
        <p>
          BlueSkyIT có quyền thay đổi nội dung chính sách bảo mật bất kỳ lúc nào
          mà không cần thông báo trước. Bạn có trách nhiệm thường xuyên kiểm tra
          để đảm bảo hiểu rõ và tuân theo chính sách bảo mật mới nhất.
        </p>
      </section>
    </div>
  );
}
